import { Done } from 'components/product/product-import/done/Done'
import { capitalize, replaceAll } from 'utils/utils'
import { useEffect, useState } from 'react'

export const DoneContainer = ({ importResult }) => {
    const [showError, setShowError] = useState(false)

    const setShowErrorHandler = (value) => {
        setShowError(value)
    }

    const skippedMessage = () => {
        let message = ''
        Object?.entries(importResult?.skipped || {})?.forEach(([key, item], index) => {
            if (item?.length) {
                message += `${capitalize(replaceAll(key, '_', ' '))}:\n`
                item?.map((i) => (message += `- ${i}\n`))
                message += Object?.keys(importResult?.skipped).length === index + 1 ? '' : '\n'
            }
        })
        return message
    }

    useEffect(() => {
        setShowError(importResult?.statistics?.total_invalid || skippedMessage() || importResult?.invalid_ids?.length)
    }, [])

    const props = {
        importResult,
        showError,
        setShowErrorHandler,
        skippedMessage,
    }

    return <Done {...props} />
}
